export default __webpack_public_path__ + "static/media/people.de19f7d5.svg";